function calcularDiaEntrega() {
  const diasFestivos = [
    "01-01",
    "01-06",
    "05-01",
    "08-15",
    "10-12",
    "11-01",
    "12-06",
    "12-08",
    "12-25"
  ];

  const ahora = new Date();
  const horaLimite = 15;
  const tiempoEnvio = 24;

  let minutosParaPedido;

  if (ahora.getHours() < horaLimite) {
    minutosParaPedido =
      (horaLimite - ahora.getHours() - 1) * 60 +
      (60 - ahora.getMinutes());
  } else {
    minutosParaPedido =
      (24 - ahora.getHours() + horaLimite - 1) * 60 +
      (60 - ahora.getMinutes());
  }

  let horasParaPedido = Math.floor(minutosParaPedido / 60);
  minutosParaPedido = minutosParaPedido % 60;

  let fechaEnvio = new Date(ahora);
  fechaEnvio.setMinutes(
    fechaEnvio.getMinutes() + minutosParaPedido + horasParaPedido * 60
  );

  let horasAgregadas = 0;
  while (horasAgregadas < tiempoEnvio) {
    fechaEnvio.setMinutes(fechaEnvio.getMinutes() + 60);

    const diaSemana = fechaEnvio.getDay();
    const esFinDeSemana = diaSemana === 0 || diaSemana === 6;

    const fechaISO = fechaEnvio.toISOString().split("T")[0];
    const mesDia = fechaISO.slice(5);
    const esDiaFestivo = diasFestivos.includes(mesDia);

    if (!esFinDeSemana && !esDiaFestivo) {
      horasAgregadas++;
    }
  }

  const opcionesFecha = {
    weekday: "short",
    month: "short",
    day: "numeric",
    timeZone: "Europe/Madrid",
  };

  const fechaEntrega = fechaEnvio.toLocaleDateString("es-ES", opcionesFecha);
  const diaActual = ahora.getDay();

  const esEntregaManana =
    fechaEnvio.getDate() === ahora.getDate() + 1 ||
    (ahora.getHours() >= horaLimite &&
      fechaEnvio.getDate() === ahora.getDate());

  if (esEntregaManana && diaActual >= 1 && diaActual <= 4) {
    return `Haz el pedido antes de <span>${horasParaPedido > 0 ? horasParaPedido : ""} ${horasParaPedido === 1 ? "hora y" : horasParaPedido > 1 ? "horas y" : ""} ${minutosParaPedido} minutos</span> y recíbelo <span>entre mañana y el siguiente día hábil</span>.`;
  } else {
    return `Haz el pedido antes de <span>${horasParaPedido > 0 ? horasParaPedido : ""} ${horasParaPedido === 1 ? "hora y" : horasParaPedido > 1 ? "horas y" : ""} ${minutosParaPedido} minutos</span> y recíbelo antes del <span>${fechaEntrega}</span>.`;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const elementos = document.querySelectorAll(".entrega-item");
  elementos.forEach(function (el) {
    el.innerHTML = calcularDiaEntrega();

    // Estilos inline (forzados)
    el.style.marginTop = "12px";
    el.style.padding = "12px 16px";
    el.style.background = "#f5f7f6";
    el.style.borderLeft = "4px solid #2e7d32";
    el.style.borderRadius = "4px";
    el.style.fontSize = "14px";
    el.style.lineHeight = "1.4";
  });

  const spans = document.querySelectorAll(".entrega-item span");
  spans.forEach(function (sp) {
    sp.style.fontWeight = "600";
    sp.style.color = "#2e7d32";
  });
});

